import { DisplayItem, PcmCodeDivision } from '../../../../external/MasterDetailApi';
import { MessageInfo } from '../../../../external/MessageListApi';
import { MessageDisplayMethodInfo } from '../../../../external/MessageDisplayMethodListApi';
import { ItemImageInfo } from '../../../../external/MasterItemImageApi';
import { ProhibitedWordInfo } from '../../../../external/MasterProhibitedWordApi';
import { ApplicationVariableInfo } from '../../../../external/MasterApplicationVariableApi';
import { MasterAnnotationProps } from '../../../../external/MasterAnnotationsApi';

export interface MasterInfoState {
  messageList: Array<MessageInfo>;
  messageDisplayMethodList: Array<MessageDisplayMethodInfo>;
  displayItemList: Array<DisplayItem>;
  pcmCodeDivisionList: Array<PcmCodeDivision>;
  annotationMstList: Array<MasterAnnotationProps>;
  itemImageList: Array<ItemImageInfo>;
  prohibitedWordMstList: Array<ProhibitedWordInfo>;
  applicationVariableMstList: Array<ApplicationVariableInfo>;
}

export const initialMasterInfoState: MasterInfoState = {
  messageList: [],
  messageDisplayMethodList: [],
  displayItemList: [],
  pcmCodeDivisionList: [],
  annotationMstList: [],
  itemImageList: [],
  prohibitedWordMstList: [],
  applicationVariableMstList: [],
};
